module.exports = __webpack_public_path__ + "img/bg-bean-04.a025c857.png";